import request from '@/utils/request';
import ajax from "../../../manage/src/utils/ajax";

/*列表*/
export function getDocumentList(parameter) {
  console.log(parameter);
  // parameter需要带参数chan_id
  return request({
    url: '/channel/doc',
    method: 'get',
    params: parameter
  })
}

/*详情*/
export function getOneDoc(parameter) {
  if (parameter) {
    return request({
      url: '/channel/doc/' + `${parameter}` + "/content",
      method: 'get',
    })
  } else {
    return null;
  }
}

export function hit(parameter) {
  return request({
    url: "/channel/doc/" + parameter.pkid + "/hit",
    method: 'get'
  })
}
